/*
 * Copyright (c) 2021. American Express Company
 */

export enum ValueVariants {
    POSITIVE = 'positive',
    NEGATIVE = 'negative',
    WARNING = 'warning'
}
